var _circle, _line, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuSendMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9884,
    cy: 11.15,
    r: 7.15,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.7885,
    y1: 11.5,
    x2: 17.6635,
    y2: 11.5,
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16345 7.875C10.4142 5.74533 12.377 4.5 15.0546 4.5C19.0497 4.5 22.2885 7.68997 22.2885 11.625C22.2885 15.56 19.0497 18.75 15.0546 18.75C13.8589 18.75 12.7309 18.4643 11.7373 17.9583",
    stroke: "#525D71",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.64 18.2962C11.7285 18.2548 11.7871 18.1511 11.7871 18.0444C11.7877 17.9382 11.7302 17.8382 11.6417 17.7961C10.2971 17.1539 9.6159 16.0256 9.27476 14.8455C9.20012 14.5881 9.24103 14.3588 9.38534 14.141C9.5302 13.9227 9.7602 13.8465 10.0046 13.8465L11.227 13.8465C11.4299 13.8465 11.6168 13.6092 11.7158 13.4153C11.8164 13.2201 11.812 12.8926 11.7058 12.7005L7.76701 5.55068C7.66528 5.36588 7.48338 5.25 7.28821 5.25C7.09248 5.25 6.91058 5.36466 6.80885 5.54885L2.87002 12.7041C2.76497 12.895 2.7611 13.2189 2.86007 13.414C2.95959 13.608 3.14647 13.8465 3.34938 13.8465L4.67688 13.8465C5.08326 13.8465 5.42827 14.1179 5.49462 14.5612C5.83796 16.891 7.65091 18.75 9.83816 18.75C10.3413 18.75 11.039 18.5774 11.64 18.2962Z",
    fill: "white",
    stroke: "#525D71",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuSendMoney);
export default __webpack_public_path__ + "static/media/ic-menu-send-money.2fe220a08424e25f9a68ea0df099f2fa.svg";
export { ForwardRef as ReactComponent };